import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  EMAIL_VERIFICATION_PATH,
  LOGIN_PATH,
  OPEN_CARDS_PATH,
  PASSWORD_RESET_CODE_PATH,
  PASSWORD_RESET_PATH,
  REQUEST_PASSWORD_RESET_PATH,
  USER_DETAILS_PATH,
} from '~/routes/paths';

type TGlobalLocationState = {
  preventScrollToTop?: boolean;
};

export type TLocationStateConfig = {
  [LOGIN_PATH]: { email?: string };
  [USER_DETAILS_PATH]: { openRecruiter: true };
  [REQUEST_PASSWORD_RESET_PATH]: { email?: string };
  [PASSWORD_RESET_CODE_PATH]: { email: string };
  [PASSWORD_RESET_PATH]: { token?: string };
  [OPEN_CARDS_PATH]: { cards: Array<unknown> };
  [EMAIL_VERIFICATION_PATH]: { isCodeRequested?: true };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useAppHistory() {
  const history = useHistory();
  return useMemo(() => {
    const { push, replace } = history;

    history.push = <Path extends keyof TLocationStateConfig>(
      path: Path | string,
      state?: TLocationStateConfig[Path] & TGlobalLocationState,
    ) => {
      return push(path, state);
    };
    history.replace = <Path extends keyof TLocationStateConfig>(
      path: Path | string,
      state?: TLocationStateConfig[Path] & TGlobalLocationState,
    ) => {
      return replace(path, state);
    };

    return history;
  }, [history]);
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useAppLocation<T extends keyof TLocationStateConfig>() {
  return useLocation<Partial<
    TLocationStateConfig[T] & TGlobalLocationState
  > | null>();
}
